import * as Models from '../ts/rlAdmin.models';
import * as Consts from "../ts/rlAdmin.consts";
import * as angular from "angular";
import { StorageService } from '../services/storage-service';
import { JsonUtil } from '../ts/rlAdmin.utils';
import { ReportService } from "../services/report-service";
import { NotifyService } from "../services/notify-service";


export interface IAvailsSelectedCriteriaScope extends ng.IScope {
    filterModel: Models.IRightsFilterModel;
    rowLength: number;
    mode: string;
}

export function RLAvailsSelectedCriteria() {
    var directive: ng.IDirective = {
        restrict: "EA",
        template: require("/assets/app/templates/avails-selected-criteria.html"),
        controllerAs: "ascVM",
        controller: AvailsSelectedCriteriaController,
        scope: {
            filterModel: "=",
            rowLength: "=",
            mode: "="
        },
        bindToController: true,
        link: (scope: IAvailsSelectedCriteriaScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: AvailsSelectedCriteriaController) => { }
    }

    return directive;
}

export class AvailsSelectedCriteriaController {
    static $inject = ["$scope", "$location", "$window", "$q", "$log", "$sce", "storage", "reportService", "notifyService"];

    filterModel: Models.IRightsFilterModel;
    rowLength: number;
    mode: string;
    criteriaName: string;
    selectedCriteria: Models.IAvailsSavedSelectedCriteriaModel;
    savedAvailsSelectedCriterias: Models.IAvailsSavedSelectedCriteriaModel[];
    savedAvailsSelectedCriteria: Models.IAvailsSavedSelectedCriteriaModel;
    savedAvailsSelectedCriteriasKey: string;
    initialLoad: boolean
    reportKey: string;
    isGlobal: 0;

    constructor(private $scope: ng.IScope,
        private $location: ng.ILocationService,
        private $window: ng.IWindowService,
        private $q: ng.IQService,
        private $log: ng.ILogService,
        private $sce: ng.ISCEService,
        private storage: StorageService,
        private reportService: ReportService,
        private notifyService: NotifyService) {

        this.initialLoad = true;
        this.criteriaName = "";
        this.savedAvailsSelectedCriterias = [];
        this.savedAvailsSelectedCriteriasKey = "savedAvailsSelectedCriterias_" + Consts.userDivAppUrlHash;
        this.reportKey = "";

        $scope.$watch(() => this.initialLoad, (newValue, oldValue) => {
            if (newValue) {
                this.GetSavedAvailsSelectedCriterias();
            }
        });

        $scope.$watch(() => this.selectedCriteria, (newValue, oldValue) => {
            if (newValue != oldValue && newValue != null) {
                this.UpdateFilterModel();
            }
        });

        $scope.$watch(() => this.mode, (newValue, oldValue) => {
            if (newValue != null) {
                var mode = _.parseInt(newValue);
                switch (mode) {
                    case 0:
                        this.reportKey = "RightsTimeline";
                        break;
                    case 1:
                        this.reportKey = "CatalogAvails";
                        break;
                    case 2:
                        this.reportKey = "AvailsWindows";
                        break;
                    case 4:
                        this.reportKey = "DealSearch";
                        break;
                    default:
                        this.reportKey = "";
                        break;
                }
            }
        });

        this.Init();
    }

    Init() {
        this.MoveSavedReportsFromLocalStorageToDB();
    }

    SaveAvailsSelectedCriteria() {
        if (_.any(this.savedAvailsSelectedCriterias, sv => sv.mode == this.mode && sv.criteriaName.toLowerCase() == this.criteriaName.toLowerCase())) {
            alert("There is already Saved Report with this name " + this.criteriaName + ", Please select another report name.");
        }
        else {
            var currentSelectedCriteria: Models.IAvailsSavedSelectedCriteriaModel = {
                criteriaName: this.criteriaName,
                mode: this.mode,
                selectedFilterModel: this.filterModel
            }

            this.notifyService.startProgress();
            this.initialLoad = true;

            let savedReportForKey: Models.ISaveReportCriteria = {
                nameSpace: Consts.ReportNameSpace.OOTBAvails,
                reportName: this.reportKey,
                savedReports: [],
                savedReportsJson: JsonUtil.Stringify(currentSelectedCriteria),
                isGlobal: Consts.IsGlobal.No
            };

            this.reportService.saveReportCriteria(savedReportForKey)
                .then((result) => {
                    if (result.data) {
                        this.notifyService.notifySuccess("Successfully saved report parameters");
                    }
                    else {
                        this.notifyService.notifyError("Failed to saved report parameters");
                    }
                    this.notifyService.endProgress();
                    this.criteriaName = "";
                    this.initialLoad = false;
                })
                .finally(() => {
                    this.GetSavedAvailsSelectedCriterias();
                });
        }
    }

    GetSavedAvailsSelectedCriterias() {
        this.initialLoad = true;
        this.reportService.getSavedReportsList(Consts.ReportNameSpace.OOTBAvails, this.criteriaName, Consts.IsGlobal.No)
            .then((result) => {
                this.savedAvailsSelectedCriterias = [];
                if (result != null) {
                    var storedAvailsSelectedCriterias: string[] = JsonUtil.Parse(result.savedReportsJson) || [];
                    _.forEach(storedAvailsSelectedCriterias, (storedAvailsSelectedCriteria) => {
                        var parsedReport: Models.IAvailsSavedSelectedCriteriaModel = JsonUtil.Parse(storedAvailsSelectedCriteria);
                        if (parsedReport.mode == this.mode) {
                            this.savedAvailsSelectedCriterias.push(parsedReport);
                        }
                    });
                }
            })
            .finally(() => {
                this.initialLoad = false;
            });
    }

    ClearAllSavedCriterias() {
        if (this.$window.confirm("Are you sure you want to clear out all Saved Criteria?")) {
            this.notifyService.startProgress();
            let deleteReportForKey: Models.ISaveReportCriteria = {
                nameSpace: Consts.ReportNameSpace.OOTBAvails,
                reportName: this.reportKey,
                savedReports: [],
                isGlobal: Consts.IsGlobal.No,
                savedReportsJson: ""
            };

            this.reportService.deleteReportCriteria(deleteReportForKey)
                .then(() => {
                    this.selectedCriteria = null;
                    this.notifyService.endProgress();
                })
                .finally(() => {
                    this.GetSavedAvailsSelectedCriterias();
                });
        }
    }

    ApplySavedCriteria(sarpSelection: Models.IAvailsSavedSelectedCriteriaModel) {
        this.selectedCriteria = sarpSelection;
    }

    ClearSpecificSavedCriteria(deleteSavedReport: Models.IAvailsSavedSelectedCriteriaModel) {
        this.initialLoad = true;
        this.notifyService.startProgress();
        let deleteReportForKey: Models.ISaveReportCriteria = {
            nameSpace: Consts.ReportNameSpace.OOTBAvails,
            reportName: this.reportKey,
            savedReports: [],
            isGlobal: Consts.IsGlobal.No,
            savedReportsJson: JsonUtil.Stringify(deleteSavedReport)
        };

        this.reportService.deleteReportCriteria(deleteReportForKey)
            .then((result) => {
                if (result.data) {
                    if (this.selectedCriteria != undefined && deleteSavedReport.criteriaName == this.selectedCriteria.criteriaName) {
                        this.selectedCriteria = null;
                    }
                    this.notifyService.notifySuccess(deleteSavedReport.criteriaName + " has been deleted.");
                }
                else {
                    this.notifyService.notifyError("Failed to delete report " + deleteSavedReport.criteriaName);
                }
                this.notifyService.endProgress();
            })
            .finally(() => {
                this.GetSavedAvailsSelectedCriterias();
            });
    }

    UpdateFilterModel() {
        if (_.any(this.savedAvailsSelectedCriterias, criteria => criteria.criteriaName == this.selectedCriteria.criteriaName && criteria.mode == this.mode)) {
            var selectedSavedAvailsSearchCriteria = _.find(this.savedAvailsSelectedCriterias, criteria => criteria.criteriaName == this.selectedCriteria.criteriaName && criteria.mode == this.mode);
            this.filterModel = selectedSavedAvailsSearchCriteria.selectedFilterModel;
        }
    }

    MoveSavedReportsFromLocalStorageToDB() {
        this.initialLoad = true;
        this.reportService.getSavedReportsList(Consts.ReportNameSpace.OOTBAvails, this.reportKey, Consts.IsGlobal.No)
            .then((result) => {
                let hasAnySavedReports: boolean = false;

                if (result != null) {
                    var storedDBAvailsSelectedCriterias: string[] = JsonUtil.Parse(result.savedReportsJson) || [];
                    if (storedDBAvailsSelectedCriterias.length > 0) {
                        hasAnySavedReports = true;
                    }
                }

                if (!hasAnySavedReports) {
                    var allSavedReport: Models.ISaveReportCriteria[] = [];
                    var storedAvailsSelectedCriterias: Models.IAvailsSavedSelectedCriteriaModel[] = this.storage.get(this.savedAvailsSelectedCriteriasKey) || [];
                    var allSavedReport: Models.ISaveReportCriteria[] = [];

                    if (storedAvailsSelectedCriterias.length > 0) {
                        _.forEach(storedAvailsSelectedCriterias, (storedReportCriteria) => {

                            let savedReportForKey: Models.ISaveReportCriteria = {
                                nameSpace: Consts.ReportNameSpace.OOTBAvails,
                                reportName: this.reportKey,
                                savedReports: [],
                                savedReportsJson: JsonUtil.Stringify(storedReportCriteria),
                                isGlobal: Consts.IsGlobal.No
                            };

                            allSavedReport.push(savedReportForKey);
                        });

                        if (allSavedReport.length > 0) {
                            this.reportService.moveSavedReportsFromLocalStorageToDB(allSavedReport);
                        }
                    }
                }
            }).finally(() => {
                this.GetSavedAvailsSelectedCriterias();
            });
    }
}